const icon1 = document.getElementById('d6-icon-1');
const icon2 = document.getElementById('d6-icon-2');
const cardContentAllDivs = document.getElementsByClassName('card__content');
const allInnerCards = document.getElementsByClassName('card__inner');
const custonClassDivs = document.getElementsByClassName('d6-custom-class')
const multipleClassNameDiv = document.querySelectorAll('.card--card.gradient, .card__inner.gradient')
const gridItems = document.getElementsByClassName('grid__item');
const cardHeadings = document.getElementsByClassName('card__heading');
const cardInfo = document.getElementsByClassName('card-information');
const cards = document.querySelectorAll('.card.card--card.card--media.color-background-2.gradient');
const pDescription = document.querySelectorAll(".d6-description-card");
const dTag = document.querySelectorAll(".d6-nutrition-tag");
const review_star = document.querySelectorAll(".d6-reviews-app");

icon1.classList.add('d6-background-color')

icon2.addEventListener('click', ()=>{
  icon1.classList.remove('d6-background-color');
  icon2.classList.add('d6-background-color');
  for (let element of cardContentAllDivs) {
    element.classList.add('d6-cardContentAllDivs');
  }
  for (let element of allInnerCards) {
    element.classList.add('d6-allInnerCards');
  }
  for (let element of custonClassDivs) {
    element.classList.add('d6-custonClassDivs');
  }
  for (let element of multipleClassNameDiv) {
    element.classList.add('d6-multipleClassNameDiv');
  }
  for (let element of gridItems) {
    element.classList.add('d6-gridItems');
  }
  for (let element of cardHeadings) {
    element.classList.add('d6-cardHeadings');
  }
  for (let element of cardInfo) {
    element.classList.add('d6-cardInfo');
  }
  for (let element of cards) {
    element.classList.add('d6-cards');
  }
  for (let element of pDescription) {
    element.classList.remove('d6-description-list-view');
  }
  for (let element of dTag) {
    element.classList.remove('d6-nutrition-list');
  }
  for (let element of review_star){
  element.style.display = "flex";
  }
})

icon1.addEventListener('click', ()=>{
  icon1.classList.add('d6-background-color');
  icon2.classList.remove('d6-background-color');
  for (let element of cardContentAllDivs) {
    element.classList.remove('d6-cardContentAllDivs');
  }
  for (let element of allInnerCards) {
    element.classList.remove('d6-allInnerCards');
  }
  for (let element of custonClassDivs) {
    element.classList.remove('d6-custonClassDivs');
  }
  for (let element of multipleClassNameDiv) {
    element.classList.remove('d6-multipleClassNameDiv');
  }
  for (let element of gridItems) {
    element.classList.remove('d6-gridItems');
  }
  for (let element of cardHeadings) {
    element.classList.remove('d6-cardHeadings');
  }
  for (let element of cardInfo) {
    element.classList.remove('d6-cardInfo');
  }
  for (let element of cards) {
    element.classList.remove('d6-cards');
  }
  for (let element of pDescription) {
    element.classList.add('d6-description-list-view');
  }
  for (let element of dTag) {
    element.classList.add('d6-nutrition-list');
  }
  for (let element of review_star){
  element.style.display = "block";
  }
})